{
  "enum": {
    "IxcQuoteV1QuoteOutcome": {
      "INACTIVE": "Inactive",
      "MARKET_CLOSED": "Market Closed",
      "NOT_FOUND": "Not Found",
      "SUCCESS": "Success",
      "UNSPECIFIED": "Unspecified"
    }
  }
}